
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRainShowersPolartwilight as ObiRainShowersPolartwilightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-rain-showers-polartwilight.js';
 
 
 

 
 export const ObiRainShowersPolartwilight = createComponent({
   react: React,
   tagName: 'obi-rain-showers-polartwilight',
   elementClass: ObiRainShowersPolartwilightElement,
   events: {
     
   }
  });
 
 